import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    const maxItems = this.element.dataset.maxItems || 1

    // evita doppia inizializzazione
    if (this.element.tomselect) return

    // inizializza TomSelect
    this.select = new TomSelect(this.element, {
      create: false,
      maxItems: maxItems === "null" ? null : parseInt(maxItems, 10),
      sortField: { field: "text", direction: "asc" },
      plugins: ["dropdown_input", "remove_button"],
      render: {
        optgroup_header: function (data, escape) {
          return `<div class="bg-grey-100 text-grey-800 px-2 py-1 text-sm font-semibold">${escape(data.label)}</div>`;
        }
      }
    })

    // memorizza l'istanza sul select per evitare doppie inizializzazioni
    this.element.tomselect = this.select

    // aggiunta → delay lungo
    this.select.on("item_add", () => {
      this.callAutosave(1000)
    })

    // rimozione → delay breve
    this.select.on("item_remove", () => {
      this.callAutosave(100)
    })
  }

  disconnect() {
    if (this.select) {
      this.select.destroy()
      this.element.tomselect = null
    }
  }

  callAutosave(delay) {
    const form = this.element.form
    if (!form) return

    // recupera il controller autosave dal form
    const autosaveController = this.application.getControllerForElementAndIdentifier(form, "autosave")
    if (autosaveController) {
      autosaveController.scheduleSubmit(this.element, delay)
    } else {
      console.warn("Controller autosave non trovato sul form")
    }
  }
}
